import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import Api from "../../../../Services/Api";
import * as R from "ramda";
import {mapToObjectDDL} from "../../../common/mapper";

class MasterLocatorFilter extends Component {
    statusOptions = [
        {
            label: "ACTIVE",
            value: "ACTIVE",
        },
        {
            label: "INACTIVE",
            value: "INACTIVE",
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            dataCabang: [],
            dataLocator: [],
        };
    }

    componentDidMount() {
        this.fetchDataLocator();
        this.fetchDataCabang();
    }

    handleSubmit = () => {
        this.props.onSubmit();
    };

    fetchDataLocator = async (body) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam(
                body && Object.keys(body).length > 0 ?
                    body :
                    {paramFilters: {}}
            );

            if (response.ok || !R.isEmpty(response.data)) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataLocator: response.data.data,
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    fetchDataCabang = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataCabang: response.data.data,
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleDDL
                                id="select_options_kode_lokasi"
                                name="kodeLocation"
                                label="Kode Lokasi"
                                box="search"
                                isClearable
                                options={this.state.dataLocator ? this.state.dataLocator.map(
                                    item => mapToObjectDDL(
                                        item.kodeLocation,
                                        item.kodeLocation
                                    )) : null}
                                value={this.props.selectedData.kodeLocation}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_kode_cabang"
                                name="kodeCabang"
                                label="Kode Cabang"
                                box="search"
                                isClearable
                                options={this.state.dataCabang ? this.state.dataCabang.map(
                                    item => mapToObjectDDL(
                                        item.kodeCabang,
                                        item.kodeCabang
                                    )) : null}
                                value={this.props.selectedData.kodeCabang}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleInput
                                id="input_text_nama_lokasi"
                                name="nameLocation"
                                label="Nama Lokasi"
                                value={this.props.selectedData.nameLocation}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_status"
                                name="status"
                                label="Status"
                                box="search"
                                isClearable
                                options={this.statusOptions}
                                value={this.props.selectedData.status}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <div style={{ textAlign: "center" }}>
                                <SimpleButton
                                    type="button"
                                    secondary
                                    onClick={() => this.props.onClearFilter()}
                                >
                                    Hapus
                                </SimpleButton>
                                <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
                            </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterLocatorFilter;